<template>
  <div>
    <!-- <MultiInput /> -->
    <!-- <div>
      <ion-item>
        <ion-label>Search Column:</ion-label>
        <ion-input v-model="searchText"></ion-input>
      </ion-item>
    </div> -->
    <div class="table-grid-container">
      <table-grid-mobile :title="title" :headers="filteredHeaders" :rows="filteredRows" />
    </div>
    
  </div>
</template>

<script>
import _ from 'lodash';
import TableGridMobile from './TableGridMobile';
import MultiInput from './MultiInput';

export default {
  name: "TableGridMobileWithSearch",
  props: ['title', 'headers', 'rows'],
  components: {
    TableGridMobile,
    MultiInput
  },
  data() {
    return {
      nationalId : +process.env.VUE_APP_NATIONAL_ID,
      searchText: ''
    }
  },
  methods: {
    styleGridTemplateColumns(frontColumns, numColumns) {
      const style = {gridTemplateColumns: `${frontColumns} repeat(${numColumns}, 2.5rem)`};
      return style;
    }
  },
  computed: {
    indexToFilter() {
      const indexes = [];
      for (let i = 0; i < this.headers.length; i++) {
        const isIncluded = this.headers[i].toLowerCase().includes(this.searchText.toLowerCase());
        if (isIncluded) indexes.push(i);
      }
      return indexes;
    },
    filteredHeaders() {
      // const filtered = _.filter(this.headers, (h) => h.trim() === '' ? true : h.toLowerCase().includes(this.searchText.toLowerCase()));
      const filtered = [];
      for (let i = 0; i < this.indexToFilter.length; i++) {
        filtered.push(this.headers[this.indexToFilter[i]]);
      }
      return filtered ? filtered : [];
    },
    filteredRows() {
      const filtered = [];
      for (let r = 0; r < this.rows.length; r++) {
        const row = [];
        for (let i = 0; i < this.indexToFilter.length; i++) {
          row.push(this.rows[r][this.indexToFilter[i]]);
        }
        filtered.push(row);
      }
      return filtered ? filtered : [];
    }
  }
};
</script>

<style scoped>
.table-grid-container {
  margin-top: 1rem;
  width: 100%;
}
</style>
